var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStramlineIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2070",
    "data-name": "Group 2070",
    transform: "translate(-788 -1322)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(788 1322)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(797.986 1331.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3404",
    "data-name": "Path 3404",
    d: "M46.967,7.749a.646.646,0,0,0-.646-.64h-.005a.646.646,0,0,0-.64.651L45.686,9.1a19.933,19.933,0,0,0-31.679-.541.646.646,0,0,0,1.016.8,18.633,18.633,0,0,1,29.648.553H43.3a.646.646,0,1,0,0,1.291h3.039a.654.654,0,0,0,.646-.651Z",
    transform: "translate(-9.392)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3405",
    "data-name": "Path 3405",
    d: "M91.5,45.906a19.216,19.216,0,0,0-1.312-7,.645.645,0,1,0-1.2.469,17.926,17.926,0,0,1,1.223,6.535A18.154,18.154,0,0,1,78.035,63.043l.7-1.067a.646.646,0,0,0-1.081-.706l-1.54,2.356a.653.653,0,0,0,.28.944l2.594,1.144a.646.646,0,0,0,.521-1.181l-.811-.357A19.433,19.433,0,0,0,91.5,45.906Z",
    transform: "translate(-51.474 -25.392)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3406",
    "data-name": "Path 3406",
    d: "M21.017,62.488q-.381.015-.766.015A18.378,18.378,0,0,1,1.766,44.275,18.438,18.438,0,0,1,3.225,38.4l.569,1.26a.646.646,0,0,0,1.177-.531l-1.2-2.663a.653.653,0,0,0-.877-.312L.357,37.419a.646.646,0,0,0,.578,1.155l1.04-.521a19.189,19.189,0,0,0-1.5,6.223A19.671,19.671,0,0,0,20.251,63.795q.411,0,.817-.016a.646.646,0,0,0-.051-1.29h0Z",
    transform: "translate(0 -23.762)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3407",
    "data-name": "Path 3407",
    d: "M52.544,48.429a4.433,4.433,0,1,0,4.547,4.432A4.5,4.5,0,0,0,52.544,48.429Z",
    transform: "translate(-32.504 -32.123)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3408",
    "data-name": "Path 3408",
    d: "M46.253,32.436H44.98a10.165,10.165,0,0,0-1.141-2.8l.909-.908a1.539,1.539,0,0,0,.059-2.071c-.239-.278-1.275-1.336-1.541-1.59a1.535,1.535,0,0,0-2.079-.055l-.9.9a10.48,10.48,0,0,0-2.763-1.168V23.459a1.487,1.487,0,0,0-1.44-1.492c-.37-.012-1.857-.02-2.225,0a1.523,1.523,0,0,0-1.44,1.492v1.322a10.214,10.214,0,0,0-2.809,1.139l-.911-.909a1.544,1.544,0,0,0-2.072-.059c-.279.239-1.339,1.272-1.594,1.538a1.531,1.531,0,0,0-.055,2.079l.9.9a10.437,10.437,0,0,0-1.169,2.755H23.416a1.519,1.519,0,0,0-1.44,1.492c-.011.369-.02,1.853,0,2.221a1.523,1.523,0,0,0,1.493,1.439h1.273a10.175,10.175,0,0,0,1.141,2.8l-.91.908a1.539,1.539,0,0,0-.059,2.071c.239.278,1.275,1.336,1.541,1.591a1.536,1.536,0,0,0,2.079.055l.9-.9A10.481,10.481,0,0,0,32.2,45.067v1.286A1.519,1.519,0,0,0,33.7,47.792c.37.011,1.857.02,2.225,0a1.523,1.523,0,0,0,1.44-1.492V45.031a10.224,10.224,0,0,0,2.809-1.139l.911.909a1.543,1.543,0,0,0,2.072.058c.279-.239,1.339-1.272,1.594-1.537a1.53,1.53,0,0,0,.055-2.079l-.9-.9a10.448,10.448,0,0,0,1.169-2.756H46.36a1.522,1.522,0,0,0,1.38-1.069c.09-.3.041-2.839.056-2.723a1.519,1.519,0,0,0-1.542-1.359ZM34.914,40.655a5.724,5.724,0,1,1,5.838-5.723A5.787,5.787,0,0,1,34.914,40.655Z",
    transform: "translate(-14.874 -14.195)",
    fill: "#fafafa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStramlineIcon);
export default __webpack_public_path__ + "static/media/stramline-icon.c1347a4771a74e16b8bc5c9b8b038c88.svg";
export { ForwardRef as ReactComponent };